

import {createRouter, createWebHashHistory} from 'vue-router'

import index from '../views/index/index'
import login from '../views/login/login'
import home from '../views/home/home'
import info from '../views/info/info'
import score from '../views/score/score'
import user from '../views/user/user'



const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/home',
    name: 'home',
    component: home,
  },
  {
    path: '/info',
    name: 'info',
    component: info,
  },
  {
    path: '/score',
    name: 'score',
    component: score,
  },
  {
    path: '/user',
    name: 'user',
    component: user,
  }
]

export default createRouter({
  history: createWebHashHistory(),
  routes: routes
})